import { createAction } from "redux-actions";
import axios from "axios";
import { call, put, takeEvery } from "redux-saga/effects";
import buildUrl from "build-url";
import AuthService from "services/auth.service";
import { FETCH_COMPANY, FETCH_DEALS, FETCH_STAKEHOLDERS, FETCHING_COMPANY_FAILED, 
  FETCHING_COMPANY_SUCCEEDED, FETCHING_DEALS_FAILED, FETCHING_DEALS_SUCCEEDED, 
  FETCHING_STAKEHOLDERS_FAILED, FETCHING_STAKEHOLDERS_SUCCEEDED, INVALIDATE_MEETING_DETAILS,
  FETCH_SHARES_FOR_STAKEHOLDERS, FETCHING_SHARES_FOR_STAKEHOLDERS_SUCCEEDED, FETCHING_SHARES_FOR_STAKEHOLDERS_FAILED, FETCH_SIMILAR_DEALS, FETCHING_SIMILAR_DEALS_SUCCEEDED, FETCHING_SIMILAR_DEALS_FAILED } from "constants/actionTypes";

const apiUrl = process.env.REACT_APP_API_URL;
const MEETING_URL = `${apiUrl}/api/2.0/meeting`;
const OPPORTUNITY_URL = `${apiUrl}/api/2.0/crm/opportunities`;

export const fetchDeals = createAction(
  FETCH_DEALS,
  (emails) => {
    return { emails };
  }
);

const fetchingDealsSucceeded = createAction(
  FETCHING_DEALS_SUCCEEDED,
  (response) => {
    return { response };
  }
);

const fetchingDealsFailed = createAction(
  FETCHING_DEALS_FAILED,
  (error) => {
    return { error };
  }
);

function* fetchDealsSaga(action) {
  const { emails } = action.payload;

  const fetchDealsAPI = () => {

    return axios({
      method: "POST",
      url: `${MEETING_URL}/deals`,
      data: emails,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDealsAPI);
    yield put(fetchingDealsSucceeded(response));
  } catch (error) {
    yield put(fetchingDealsFailed(error));
  }
}

export const fetchCompany = createAction(
  FETCH_COMPANY, 
  (emails) => { 
    return { emails };
  }
);

const fetchingCompanySucceeded = createAction(
  FETCHING_COMPANY_SUCCEEDED,
  (response) => {
    return { response };
  }
);

const fetchingCompanyFailed = createAction(
  FETCHING_COMPANY_FAILED,
  (error) => {
    return { error };
  }
);

function* fetchCompanySaga(action) {
  const { emails } = action.payload;

  const fetchCompanyAPI = () => {

    return axios({
      method: "POST",
      url: `${MEETING_URL}/company`,
      data: emails,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCompanyAPI);
    yield put(fetchingCompanySucceeded(response));
  } catch (error) {
    yield put(fetchingCompanyFailed(error));
  }
}

export const fetchStakeholders = createAction(
  FETCH_STAKEHOLDERS, 
  (emails) => { 
    return { emails };
  }
);

const fetchingStakeholdersSucceeded = createAction(
  FETCHING_STAKEHOLDERS_SUCCEEDED,
  (response) => {
    return { response };
  }
);

const fetchingStakeholdersFailed = createAction(
  FETCHING_STAKEHOLDERS_FAILED,
  (error) => {
    return { error };
  }
);

function* fetchStakeholdersSaga(action) {
  const { emails } = action.payload;

  const fetchStakeholdersAPI = () => {

    return axios({
      method: "POST",
      url: `${MEETING_URL}/stakeholders`,
      data: emails,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchStakeholdersAPI);
    yield put(fetchingStakeholdersSucceeded(response));
  } catch (error) {
    yield put(fetchingStakeholdersFailed(error));
  }
}

export const fetchSharesForStakeholders = createAction(
  FETCH_SHARES_FOR_STAKEHOLDERS,
  (emails, page, limit) => {
    return { emails, page, limit };
  }
);

const fetchingSharesForStakeholdersSucceeded = createAction(
  FETCHING_SHARES_FOR_STAKEHOLDERS_SUCCEEDED,
  (response) => {
    return { response };
  }
);

const fetchingSharesForStakeholdersFailed = createAction(
  FETCHING_SHARES_FOR_STAKEHOLDERS_FAILED,
  (error) => {
    return { error };
  }
);

function* fetchingSharesForStakeholdersSaga(action) {
  const { emails, page, limit } = action.payload;

  const fetchingSharesForStakeholdersAPI = () => {

    return axios({
      method: "POST",
      url: `${MEETING_URL}/shares`,
      params: { page, limit },
      data: { emails },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchingSharesForStakeholdersAPI);
    yield put(fetchingSharesForStakeholdersSucceeded(response));
  } catch (error) {
    yield put(fetchingSharesForStakeholdersFailed(error));
  }
}

export const invalidateMeeting = createAction(
  INVALIDATE_MEETING_DETAILS
);

export const fetchSimilarDeals = createAction(
  FETCH_SIMILAR_DEALS,
  (dealId) => {
    return dealId;
  }
);

const fetchingSimilarDealsSucceeded = createAction(
  FETCHING_SIMILAR_DEALS_SUCCEEDED,
  (response) => {
    return { response };
  }
);

const fetchingSimilarDealsFailed = createAction(
  FETCHING_SIMILAR_DEALS_FAILED,
  (error) => {
    return { error };
  }
);

function* fetchSimilarDealsSaga(action) {
  const { dealId } = action.payload;
  console.log("action",action)
  const fetchSimilarDealsAPI = () => {
    return axios({
      method: "GET",
      url: `${OPPORTUNITY_URL}/${dealId}/similar-deals`
    }).then((response) => response.data);
  }
  try {
    const response = yield call(fetchSimilarDealsAPI);
    yield put(fetchingSimilarDealsSucceeded(response));
  }
  catch (error) {
    yield put(fetchingSimilarDealsFailed(error));
  }
}

export default function* meetingSaga() {
  yield takeEvery(FETCH_COMPANY, fetchCompanySaga);
  yield takeEvery(FETCH_DEALS, fetchDealsSaga);
  yield takeEvery(FETCH_STAKEHOLDERS, fetchStakeholdersSaga);
  yield takeEvery(FETCH_SHARES_FOR_STAKEHOLDERS, fetchingSharesForStakeholdersSaga);
  yield takeEvery(FETCH_SIMILAR_DEALS, fetchSimilarDealsSaga);
}
